import React from "react";
import { Button } from "react-bootstrap";
import { DialogContent, DialogTitle } from "@mui/material";
import { Dialog, DialogActions, DialogContentText } from "@material-ui/core";
import { Loader as LoaderIcon } from "react-feather";
import Pagination from "react-js-pagination";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import styles from "./MapBodyType.module.css";
import classNames from "classnames";
import useMapBodyType from "../../customHooks/MapBodyType/useMapBodyType";

const TABLE_HEADINGS = ["Sku", "Product Name"];

const MapBodyType = () => {
  const hookProps = useMapBodyType();
  // const navigate = useNavigate();
  const {
    loader,
    productsData,
    bodyTypes,
    showConfirmation,
    setShowConfirmation,
    handleChange,
    selection,
    updateProducts,
    submitLoader,
    totalRecords,
    currentPage,
    handlePageChange,
  } = hookProps;

  return (
    <>
      <div>
        <div className={styles.topheader}>
          <div className="flex justify-between">
            <span className={`p-1 ${styles.titlename}`}>
              Map Products with BodyType
            </span>
          </div>
        </div>

        <div className={styles.middle_main_container}>
          <div className="">
            {loader ? (
              <div className="screenTableRootLoader">
                <SmallLoader />
              </div>
            ) : productsData && productsData?.length > 0 ? (
              <>
                <div className={styles.containerWrapper}>
                  <div className={styles.tableWrapper}>
                    <table className="w-full border border-collapse">
                      <thead className="bg-gray-300 sticky top-0">
                        <tr>
                          {TABLE_HEADINGS.map((item, idx) => (
                            <th
                              className={classNames("p-2", {
                                "w-52": item === "Tag",
                              })}
                              key={idx}
                            >
                              {item}
                            </th>
                          ))}
                          <th>Map Body Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productsData.map((item) => (
                          <tr key={item.iProductId}>
                            <td className="border p-2">{item.sSKU}</td>

                            <td className="border p-2">{item.sName}</td>

                            <td className="border p-2">
                              <select
                                name="bodyType"
                                className="form-select border border-black bg-white py-1.5 px-2.5"
                                onChange={(e) =>
                                  handleChange(item.iProductId, e.target.value)
                                }
                                value={
                                  selection?.find(
                                    (prod) =>
                                      prod.iProductId === item.iProductId
                                  )?.iBodyTypeId || ""
                                }
                              >
                                <option>Select BodyType</option>
                                {bodyTypes?.map((bodyType) => {
                                  return (
                                    <option
                                      value={bodyType.iBodyTypeId}
                                      key={bodyType.iBodyTypeId}
                                    >
                                      {bodyType.sName}
                                    </option>
                                  );
                                })}
                              </select>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="w-full flex items-center justify-between mt-auto">
                    <div className={`flex gap-4 ${styles.bottomButtom}`}>
                      <button
                        type="submit"
                        className={`flex items-center gap-2 px-4 py-2 text-gray-800 border border-gray-300 rounded hover:bg-gray-100 cursor-pointer ${styles.modalbtnfirst}`}
                        onClick={() => setShowConfirmation(true)}
                        //   disabled={!totalSelection.length}
                      >
                        Submit
                      </button>
                    </div>

                    <div>
                      {totalRecords > 10 && (
                        <Pagination
                          activePage={currentPage}
                          itemsCountPerPage={10}
                          totalItemsCount={totalRecords}
                          pageRangeDisplayed={1}
                          onChange={handlePageChange}
                          nextPageText={"next"}
                          prevPageText={"prev"}
                          firstPageText={"<<"}
                          lastPageText={">>"}
                          itemClass="page-item"
                          linkClass="page-link"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <p>No Products Found</p>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={showConfirmation}
        onClose={() => setShowConfirmation(false)}
      >
        <DialogTitle className="newpopupstyle"></DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to submit?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {" "}
          <Button
            onClick={() => setShowConfirmation(false)}
            className="bg-red-600 hover:bg-red-700"
            // disabled={submitLoader}
          >
            Cancel
          </Button>
          {submitLoader ? (
            <button
              className={`screenFormSubmitLoaderBtn consistentBtn ${styles.modalbtn}`}
              style={{ width: "100px" }}
              disabled={submitLoader}
            >
              <LoaderIcon size={20} className="indicator" />
            </button>
          ) : (
            <button
              type="submit"
              className={`flex items-center gap-2 px-4 py-2 text-gray-800 border border-gray-300 rounded hover:bg-gray-100 cursor-pointer ${styles.modalbtn}`}
              onClick={updateProducts}
              disabled={!selection.length}
            >
              Submit
            </button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MapBodyType;
